// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"304":"f4fd9305","653":"f4fd9305"}[chunkId] + ".chunk.css";
};